package songwritersnotebook.app.screens.components

import songwritersnotebook.app.screens.*

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.LinearEasing
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.KeyboardCapitalization
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.withTimeoutOrNull
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.waitForUpOrCancellation
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.utils.NetworkUtils
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.MenuBook
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.automirrored.filled.Undo
import androidx.compose.material.icons.automirrored.filled.Redo
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.zIndex
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.unit.DpSize
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material.icons.filled.CloudDone
import androidx.compose.material.icons.filled.Save
import androidx.compose.material.icons.filled.Piano
import androidx.compose.material.icons.filled.Check
import songwritersnotebook.app.utils.rememberMicPermissionLauncher
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.MusicNote
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.geometry.CornerRadius
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import songwritersnotebook.app.billing.SubscriptionTier
import songwritersnotebook.app.billing.ProductInfo
import songwritersnotebook.app.data.*
import songwritersnotebook.app.navigation.AppRoutes
import songwritersnotebook.app.ui.theme.BlueAccent
import songwritersnotebook.app.ui.theme.GoldAccent
import songwritersnotebook.app.ui.theme.SliderThumbGray
import songwritersnotebook.app.ui.theme.SliderTrackGray
import songwritersnotebook.app.ui.theme.ChordVisualTransformation
import songwritersnotebook.app.utils.countSyllables
import songwritersnotebook.app.viewmodels.*
import kotlinx.datetime.*
import org.jetbrains.compose.resources.painterResource
import songwritersnotebookapp.composeapp.generated.resources.Res
import songwritersnotebookapp.composeapp.generated.resources.ic_guitar
import songwritersnotebook.app.ui.theme.SuccessGreen
import songwritersnotebook.app.components.SaveStatusIndicator
import songwritersnotebook.app.adaptiveSheetWidth
import songwritersnotebook.app.components.ChordPanel
import songwritersnotebook.app.components.ChordCreatorSheet
import songwritersnotebook.app.components.HarmonyAiTabContent
import songwritersnotebook.app.components.TabEditorSheet
import songwritersnotebook.app.components.RecordingSheet
import songwritersnotebook.app.components.LineMediaSheet
import songwritersnotebook.app.components.TabDisplay
import songwritersnotebook.app.components.LoadingOverlay
import songwritersnotebook.app.tutorial.TutorialManager
import songwritersnotebook.app.tutorial.TutorialStep
import songwritersnotebook.app.tutorial.tutorialTarget
import androidx.compose.material3.SegmentedButton
import androidx.compose.material3.SegmentedButtonDefaults
import androidx.compose.material3.SingleChoiceSegmentedButtonRow
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.tutorial.TutorialOverlay
import songwritersnotebook.app.LocalPlatformContext
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.unit.IntOffset
import songwritersnotebook.app.components.VersionHistorySheet
import songwritersnotebook.app.components.AdRewardButton


@Composable
fun CreditCountdownTimer(lastResetTimestamp: Long) {
    var timeLeft by remember { mutableStateOf("") }
    
    LaunchedEffect(Unit) {
        while(true) {
            val now = Clock.System.now()
            val timeZone = TimeZone.currentSystemDefault()
            val today = now.toLocalDateTime(timeZone).date
            
            val tomorrow = today.plus(kotlinx.datetime.DatePeriod(days = 1))
            
            val nextResetInstant = tomorrow.atStartOfDayIn(timeZone)
            val duration = nextResetInstant - now
            
            val days = duration.inWholeDays
            val hours = duration.inWholeHours % 24
            
            timeLeft = if (days > 0) "$days days" else "${hours}h"
            
            kotlinx.coroutines.delay(60000) 
        }
    }
    
    Text(
        text = "Refills in $timeLeft",
        style = MaterialTheme.typography.labelSmall,
        color = MaterialTheme.colorScheme.primary
    )
}


@Composable
fun AiAssistantSheet(
    onDismiss: () -> Unit,
    viewModel: EditorViewModel,
    userProfile: songwritersnotebook.app.data.UserProfile?,
    aiCreditCost: Int
) {
    // Replaced by songwritersnotebook.app.components.AiAssistantPanel
}


@Composable
fun HarmonyAssistantOverlay(
    uiState: EditorUiState,
    onApprove: (String) -> Unit,
    onReject: (String) -> Unit,
    onApproveAll: () -> Unit,
    onDismiss: () -> Unit,
    onSwipeUp: () -> Unit
) {
    val isVisible = !uiState.showAiAssistantSheet && (uiState.isHarmonyListening || uiState.isHarmonyThinking || uiState.harmonyPendingActions.isNotEmpty() || uiState.harmonySpokenResponse != null)

    
    AnimatedVisibility(
        visible = isVisible,
        enter = fadeIn() + slideInVertically { it / 2 },
        exit = fadeOut() + slideOutVertically { it / 2 }
    ) {
        val offsetX = remember { androidx.compose.animation.core.Animatable(0f) }
        val offsetY = remember { androidx.compose.animation.core.Animatable(0f) }
        val coroutineScope = rememberCoroutineScope()
        var dragAxis by remember { mutableStateOf<String?>(null) }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(bottom = 100.dp, start = 16.dp, end = 16.dp),
            contentAlignment = Alignment.BottomCenter
        ) {
            Card(
                modifier = Modifier
                    .widthIn(max = 400.dp)
                    .adaptiveSheetWidth()
                    .offset { IntOffset(offsetX.value.toInt(), offsetY.value.toInt()) }
                    .pointerInput(Unit) {
                        detectDragGestures(
                            onDragStart = {
                                dragAxis = null
                            },
                            onDragEnd = {
                                val x = offsetX.value
                                val y = offsetY.value
                                val threshold = 100f
                                if (y < -threshold && dragAxis == "y") {
                                    // Swipe Up
                                    onSwipeUp()
                                    coroutineScope.launch {
                                        offsetX.animateTo(0f)
                                        offsetY.animateTo(0f)
                                    }
                                } else if ((y > threshold && dragAxis == "y") || (kotlin.math.abs(x) > threshold && dragAxis == "x")) {
                                    // Swipe Down, Left, or Right
                                    onDismiss()
                                    coroutineScope.launch {
                                        offsetX.animateTo(0f)
                                        offsetY.animateTo(0f)
                                    }
                                } else {
                                    // Snap back
                                    coroutineScope.launch {
                                        offsetX.animateTo(0f)
                                        offsetY.animateTo(0f)
                                    }
                                }
                            },
                            onDragCancel = {
                                coroutineScope.launch {
                                    offsetX.animateTo(0f)
                                    offsetY.animateTo(0f)
                                }
                            }
                        ) { change, dragAmount ->
                            change.consume()
                            coroutineScope.launch {
                                if (dragAxis == null) {
                                    dragAxis = if (kotlin.math.abs(dragAmount.x) > kotlin.math.abs(dragAmount.y)) "x" else "y"
                                }
                                
                                if (dragAxis == "x") {
                                    offsetX.snapTo(offsetX.value + dragAmount.x)
                                } else {
                                    offsetY.snapTo(offsetY.value + dragAmount.y)
                                }
                            }
                        }
                    },
                shape = RoundedCornerShape(24.dp),
                colors = CardDefaults.cardColors(
                    containerColor = MaterialTheme.colorScheme.surfaceColorAtElevation(6.dp)
                ),
                elevation = CardDefaults.cardElevation(defaultElevation = 12.dp)
            ) {
                Column(
                    modifier = Modifier.padding(16.dp),
                    verticalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    // Status Row
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        val infiniteTransition = rememberInfiniteTransition()
                        val pulseScale by infiniteTransition.animateFloat(
                            initialValue = 1f,
                            targetValue = 1.2f,
                            animationSpec = infiniteRepeatable(
                                animation = tween(1000),
                                repeatMode = RepeatMode.Reverse
                            )
                        )

                        Box(contentAlignment = Alignment.Center) {
                            if (uiState.isHarmonyListening || uiState.isHarmonyThinking) {
                                Box(
                                    modifier = Modifier
                                        .size(12.dp)
                                        .scale(pulseScale)
                                        .background(
                                            if (uiState.isHarmonyListening) BlueAccent else GoldAccent,
                                            CircleShape
                                        )
                                )
                            } else {
                                Icon(
                                    Icons.Default.AutoAwesome,
                                    contentDescription = null,
                                    modifier = Modifier.size(20.dp),
                                    tint = MaterialTheme.colorScheme.primary
                                )
                            }
                        }

                        Text(
                            text = when {
                                uiState.isHarmonyListening -> "Harmony is listening..."
                                uiState.isHarmonyThinking -> "Harmony is thinking..."
                                uiState.harmonyPendingActions.isNotEmpty() -> "Harmony wants to take action:"
                                else -> "Harmony says:"
                            },
                            style = MaterialTheme.typography.titleSmall,
                            fontWeight = FontWeight.Bold
                        )
                    }

                    // Content
                    if (uiState.harmonySpokenResponse != null && uiState.harmonyPendingActions.isEmpty()) {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .heightIn(max = 120.dp)
                                .verticalScroll(rememberScrollState())
                        ) {
                            Text(
                                text = "\"${uiState.harmonySpokenResponse}\"",
                                style = MaterialTheme.typography.bodyLarge,
                                fontStyle = FontStyle.Italic,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                    } else if (uiState.isHarmonyListening && uiState.harmonyTranscript.isNotBlank()) {
                        Text(
                            text = "\"${uiState.harmonyTranscript}\"",
                            style = MaterialTheme.typography.bodyLarge,
                            fontStyle = FontStyle.Italic,                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }

                    if (uiState.harmonyPendingActions.isNotEmpty()) {
                        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                            uiState.harmonyPendingActions.forEach { action ->
                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .background(MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.5f), RoundedCornerShape(8.dp))
                                        .padding(8.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Text(
                                        text = action.toolName.replace("_", " ").replaceFirstChar { it.uppercase() },
                                        style = MaterialTheme.typography.bodyMedium,
                                        modifier = Modifier.weight(1f)
                                    )
                                    IconButton(onClick = { onReject(action.id) }) {
                                        Icon(Icons.Default.Close, null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(20.dp))
                                    }
                                    IconButton(onClick = { onApprove(action.id) }) {
                                        Icon(Icons.Default.Check, null, tint = SuccessGreen, modifier = Modifier.size(20.dp))
                                    }
                                }
                            }
                            
                            if (uiState.harmonyPendingActions.size > 1) {
                                Button(
                                    onClick = onApproveAll,
                                    modifier = Modifier.fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp)
                                ) {
                                    Text("Approve All Changes")
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}


@Composable
fun AiLimitDialog(
    userProfile: songwritersnotebook.app.data.UserProfile?,
    onDismiss: () -> Unit,
    onUpgrade: () -> Unit,
    onWatchAd: () -> Unit,
    aiCreditProducts: List<ProductInfo>,
    onPurchaseClick: (ProductInfo) -> Unit
) {
    val totalCredits = userProfile?.totalAiCredits ?: 0
    val isWeb = remember { songwritersnotebook.app.getPlatform().name.contains("Web", ignoreCase = true) }
    
    AlertDialog(
        onDismissRequest = onDismiss,
        icon = { Icon(Icons.Default.AutoAwesome, contentDescription = "AI", modifier = Modifier.size(48.dp)) },
        title = { Text("AI Credits Needed") },
        text = {
            Column {
                val isStudio = userProfile?.subscriptionTier == "STUDIO"
                val isAdmin = userProfile?.isAdmin == true
                
                if (isStudio && !isAdmin) {
                    Text("You have reached your daily fair-use limit for AI generation. Purchase a credit pack to continue using AI features today.")
                } else if (isWeb) {
                    Text("You have $totalCredits AI credits remaining. Purchase a credit pack to continue using AI features on the web.")
                } else {
                    Text("You have $totalCredits AI credits remaining. Get more by watching an ad or purchasing a credit pack.")
                }
                if (aiCreditProducts.isNotEmpty()) {
                    Spacer(Modifier.height(16.dp))
                    Text("Purchase Credits:", style = MaterialTheme.typography.labelLarge)
                    Spacer(Modifier.height(8.dp))
                    aiCreditProducts.forEach { product ->
                        val price = product.oneTimePurchaseOfferDetails?.formattedPrice ?: "..."
                        val displayName = product.name.replace(" AI Credits", " Credits")
                        Row(
                            modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text(displayName, style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold)
                            Button(
                                onClick = { onPurchaseClick(product) },
                                contentPadding = PaddingValues(horizontal = 12.dp, vertical = 0.dp),
                                modifier = Modifier.height(36.dp)
                            ) {
                                Text(price)
                            }
                        }
                    }
                }
            }
        },
        confirmButton = {
            Button(onClick = onUpgrade) {
                Text("Upgrade Tier")
            }
        },
        dismissButton = {
            Row(verticalAlignment = Alignment.CenterVertically) {
                if (!isWeb) {
                    AdRewardButton(
                        userProfile = userProfile,
                        onClick = onWatchAd
                    )
                }
                TextButton(onClick = onDismiss) {
                    Text("Cancel")
                }
            }
        }
    )
}


